import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3ea7d3f8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-lg container-fluid shadow-sm py-3" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "text-primary" }, "Personal Details", -1))
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-4" }
const _hoisted_5 = { class: "p-float-label prime_input" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "firstname" }, [
  /*#__PURE__*/_createTextVNode("First Name "),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_7 = { class: "col-md-4" }
const _hoisted_8 = { class: "p-float-label prime_input" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "middlename" }, "Middle Name", -1))
const _hoisted_10 = { class: "col-md-4" }
const _hoisted_11 = { class: "p-float-label prime_input" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "lastname" }, [
  /*#__PURE__*/_createTextVNode("Last Name "),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_13 = { class: "col-md-6" }
const _hoisted_14 = { class: "p-float-label prime_input" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "employeeNumber" }, [
  /*#__PURE__*/_createTextVNode("Employee Number (Ministry of Health) "),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_16 = { class: "col-md-6" }
const _hoisted_17 = { class: "p-float-label prime_input" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "email" }, [
  /*#__PURE__*/_createTextVNode("Email "),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_19 = { class: "col-md-12" }
const _hoisted_20 = { class: "p-float-label prime_input" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "address" }, [
  /*#__PURE__*/_createTextVNode("Address "),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "text-primary" }, "Approval for health need", -1))
const _hoisted_23 = { class: "row" }
const _hoisted_24 = { class: "col-md-12" }
const _hoisted_25 = { class: "m_w_input" }
const _hoisted_26 = { class: "p-float-label prime_input w_input" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "healthFacility" }, [
  /*#__PURE__*/_createTextVNode("Health Facility/Department "),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_28 = { class: "bi bi-question-circle-fill input_icon" }
const _hoisted_29 = { class: "col-md-12" }
const _hoisted_30 = { class: "m_w_input" }
const _hoisted_31 = { class: "p-float-label prime_input w_input" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "supervisorName" }, [
  /*#__PURE__*/_createTextVNode("Health Facility/Department head "),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_33 = { class: "bi bi-question-circle-fill input_icon" }
const _hoisted_34 = { class: "col-md-12" }
const _hoisted_35 = { class: "p-float-label prime_input" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "supervisorEmail" }, [
  /*#__PURE__*/_createTextVNode("Health Facility/Department head email "),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "text-primary" }, "Description of health challenge", -1))
const _hoisted_38 = { class: "row" }
const _hoisted_39 = { class: "col-12" }
const _hoisted_40 = { class: "p-float-label prime_input" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "title" }, [
  /*#__PURE__*/_createTextVNode("Title of health need "),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_42 = { class: "w-100 text-muted d-flex justify-content-end mr-3" }
const _hoisted_43 = { class: "col-md-12 mb-3" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "healthChallenge" }, [
  /*#__PURE__*/_createTextVNode("Description of health need/challenge (500 words max)"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger mx-1" }, "*")
], -1))
const _hoisted_45 = { class: "col-12 mb-3" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "solutionDescription" }, [
  /*#__PURE__*/_createTextVNode("Description of the required solution (500 words max)"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger mx-1" }, "*")
], -1))
const _hoisted_47 = { class: "m_w_input" }
const _hoisted_48 = { class: "col-12" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "selectedProgramArea" }, [
  /*#__PURE__*/_createTextVNode("Program Area"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger mx-2" }, "*")
], -1))
const _hoisted_50 = { class: "mb-3 m_w_input" }
const _hoisted_51 = {
  key: 0,
  class: "col-12"
}
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "specificProgramArea" }, [
  /*#__PURE__*/_createTextVNode("Specific Program Area"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger mx-2" }, "*")
], -1))
const _hoisted_53 = {
  key: 0,
  class: "mb-3 m_w_input"
}
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "text-primary" }, "Target end users", -1))
const _hoisted_55 = { class: "row" }
const _hoisted_56 = { class: "col-12 mb-3" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "targetValue" }, [
  /*#__PURE__*/_createTextVNode("Who are your target end users? (250 words max)"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger mx-1" }, "*")
], -1))
const _hoisted_58 = { class: "col-md-12" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "benefits" }, [
  /*#__PURE__*/_createTextVNode("Benefits to end-users and other beneficiaries (250 words max)"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger mx-1" }, "*")
], -1))
const _hoisted_60 = { class: "col-md-12" }
const _hoisted_61 = { class: "justify-content-start w-100" }
const _hoisted_62 = { class: "d-flex" }
const _hoisted_63 = { class: "d-flex justify-content-end mt-3" }
const _hoisted_64 = { class: "confirmation-content text-primary" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_66 = { class: "confirmation-content text-primary py-5" }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_MultiSelect = _resolveComponent("MultiSelect")!
  const _component_BaseFileLong = _resolveComponent("BaseFileLong")!
  const _component_BaseCheckBox = _resolveComponent("BaseCheckBox")!
  const _component_Button = _resolveComponent("Button")!
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_TermsAndConditions = _resolveComponent("TermsAndConditions")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", {
      onSubmit: _cache[20] || (_cache[20] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"])),
      ref: "createNeed"
    }, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, [
            _createVNode(_component_InputText, {
              type: "text",
              id: "firstname",
              name: "firstname",
              modelValue: _ctx.form.firstname,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.firstname) = $event)),
              autocomplete: "firstname"
            }, null, 8, ["modelValue"]),
            _hoisted_6
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("span", _hoisted_8, [
            _createVNode(_component_InputText, {
              type: "text",
              id: "middlename",
              name: "middlename",
              modelValue: _ctx.form.middlename,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.middlename) = $event)),
              autocomplete: "other-name"
            }, null, 8, ["modelValue"]),
            _hoisted_9
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("span", _hoisted_11, [
            _createVNode(_component_InputText, {
              type: "text",
              id: "lastname",
              name: "lastname",
              modelValue: _ctx.form.lastname,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.lastname) = $event)),
              autocomplete: "lastname"
            }, null, 8, ["modelValue"]),
            _hoisted_12
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("span", _hoisted_14, [
            _createVNode(_component_InputText, {
              type: "text",
              id: "employeeNumber",
              name: "employeeNumber",
              modelValue: _ctx.form.employeeNumber,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.employeeNumber) = $event))
            }, null, 8, ["modelValue"]),
            _hoisted_15
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("span", _hoisted_17, [
            _createVNode(_component_InputText, {
              type: "email",
              id: "email",
              name: "email",
              modelValue: _ctx.form.email,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.email) = $event))
            }, null, 8, ["modelValue"]),
            _hoisted_18
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("span", _hoisted_20, [
            _createVNode(_component_InputText, {
              type: "text",
              id: "address",
              autocomplete: "address",
              name: "address",
              modelValue: _ctx.form.address,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.address) = $event))
            }, null, 8, ["modelValue"]),
            _hoisted_21
          ])
        ])
      ]),
      _hoisted_22,
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("span", _hoisted_26, [
              _createVNode(_component_InputText, {
                type: "text",
                id: "healthFacility",
                name: "healthFacility",
                modelValue: _ctx.form.healthFacility,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.healthFacility) = $event))
              }, null, 8, ["modelValue"]),
              _hoisted_27
            ]),
            _withDirectives(_createElementVNode("i", _hoisted_28, null, 512), [
              [
                _directive_tooltip,
                
                'Every health need is to be approved by a health facility'
              ,
                void 0,
                { left: true }
              ]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("span", _hoisted_31, [
              _createVNode(_component_InputText, {
                type: "text",
                id: "supervisorName",
                name: "supervisorName",
                modelValue: _ctx.form.supervisorName,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.supervisorName) = $event))
              }, null, 8, ["modelValue"]),
              _hoisted_32
            ]),
            _withDirectives(_createElementVNode("i", _hoisted_33, null, 512), [
              [
                _directive_tooltip,
                
                'A supervisor not lower than a level 13 officer must approve the health need'
              ,
                void 0,
                { left: true }
              ]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("span", _hoisted_35, [
            _createVNode(_component_InputText, {
              type: "email",
              id: "supervisorEmail",
              name: "supervisorEmail",
              modelValue: _ctx.form.supervisorEmail,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.supervisorEmail) = $event))
            }, null, 8, ["modelValue"]),
            _hoisted_36
          ])
        ])
      ]),
      _hoisted_37,
      _createElementVNode("div", _hoisted_38, [
        _createElementVNode("div", _hoisted_39, [
          _createElementVNode("span", _hoisted_40, [
            _createVNode(_component_InputText, {
              type: "text",
              id: "title",
              name: "title",
              modelValue: _ctx.form.title,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.title) = $event)),
              maxlength: "120"
            }, null, 8, ["modelValue"]),
            _hoisted_41
          ]),
          _createElementVNode("small", _hoisted_42, _toDisplayString(_ctx.form.title.length) + "/120", 1)
        ]),
        _createElementVNode("div", _hoisted_43, [
          _hoisted_44,
          _createVNode(_component_Textarea, {
            modelValue: _ctx.form.healthChallenge,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.healthChallenge) = $event)),
            id: "healthChallenge",
            name: "healthChallenge",
            autoResize: true,
            rows: "5",
            cols: "30",
            placeholder: "Enter text here...",
            class: "w-100"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_45, [
          _hoisted_46,
          _createElementVNode("div", _hoisted_47, [
            _createVNode(_component_Textarea, {
              modelValue: _ctx.form.solutionDescription,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.form.solutionDescription) = $event)),
              id: "solutionDescription",
              name: "solutionDescription",
              autoResize: true,
              rows: "5",
              cols: "30",
              placeholder: "Enter text here...",
              class: "w-100"
            }, null, 8, ["modelValue"]),
            _withDirectives(_createElementVNode("i", {
              class: _normalizeClass(`bi bi-${_ctx.toolTip3.icon} input_icon`)
            }, null, 2), [
              [
                _directive_tooltip,
                _ctx.toolTip3.message,
                void 0,
                { left: true }
              ]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_48, [
          _hoisted_49,
          _createElementVNode("div", _hoisted_50, [
            _createVNode(_component_Dropdown, {
              id: "selectedProgramArea",
              name: "selectedProgramArea",
              modelValue: _ctx.form.selectedProgramArea,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.form.selectedProgramArea) = $event)),
              options: _ctx.programAreas,
              optionLabel: "name",
              optionValue: "id",
              placeholder: "Select Program Area",
              class: "w-100"
            }, null, 8, ["modelValue", "options"])
          ])
        ]),
        (_ctx.form.selectedProgramArea !== '')
          ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
              _hoisted_52,
              (_ctx.form.selectedProgramArea !== 'program_area_others')
                ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                    _createVNode(_component_MultiSelect, {
                      id: "specificProgramArea",
                      name: "specificProgramArea",
                      modelValue: _ctx.form.specificProgramArea,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.form.specificProgramArea) = $event)),
                      options: _ctx.specificPrograms,
                      filter: true,
                      optionLabel: "name",
                      optionValue: "id",
                      placeholder: "Select Specific Program Areas",
                      display: "chip",
                      class: "w-100"
                    }, null, 8, ["modelValue", "options"])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _hoisted_54,
      _createElementVNode("div", _hoisted_55, [
        _createElementVNode("div", _hoisted_56, [
          _hoisted_57,
          _createVNode(_component_Textarea, {
            modelValue: _ctx.form.targetUser,
            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.form.targetUser) = $event)),
            id: "targetUser",
            name: "targetUser",
            autoResize: true,
            rows: "5",
            cols: "30",
            placeholder: "Enter text here...",
            class: "w-100"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_58, [
          _hoisted_59,
          _createVNode(_component_Textarea, {
            modelValue: _ctx.form.benefits,
            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.form.benefits) = $event)),
            id: "benefits",
            name: "benefits",
            autoResize: true,
            rows: "5",
            cols: "30",
            placeholder: "Enter text here...",
            class: "w-100"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_60, [
          _createVNode(_component_BaseFileLong, {
            value: _ctx.fileProp,
            file: _ctx.form.file,
            "onUpdate:file": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.form.file) = $event))
          }, null, 8, ["value", "file"])
        ])
      ]),
      _createElementVNode("small", _hoisted_61, [
        _createElementVNode("p", _hoisted_62, [
          _createVNode(_component_BaseCheckBox, {
            checkbox: _ctx.form.terms,
            "onUpdate:checkbox": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.form.terms) = $event)),
            inputType: _ctx.termsProp
          }, null, 8, ["checkbox", "inputType"]),
          _createElementVNode("span", {
            class: "text-primary text-decoration-underline",
            onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.termsModal = true))
          }, "Terms and Condition")
        ]),
        _createVNode(_component_BaseCheckBox, {
          checkbox: _ctx.form.disclaimer,
          "onUpdate:checkbox": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.form.disclaimer) = $event)),
          inputType: _ctx.disclaimerProp
        }, null, 8, ["checkbox", "inputType"])
      ]),
      _createElementVNode("div", _hoisted_63, [
        _createVNode(_component_Button, {
          class: "p-button-raised p-button-text p-button-plain",
          onClick: _ctx.saveForLater
        }, {
          default: _withCtx(() => [
            _createTextVNode("Save For Later")
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_Button, {
          onClick: _ctx.formValidation,
          disabled: _ctx.loading,
          class: "p-button-primary"
        }, {
          default: _withCtx(() => [
            _createElementVNode("i", {
              class: _normalizeClass([_ctx.loading ? 'pi pi-spin pi-spinner px-2' : ''])
            }, null, 2),
            _createTextVNode(" Submit For  Approval")
          ]),
          _: 1
        }, 8, ["onClick", "disabled"])
      ])
    ], 544),
    _createVNode(_component_Dialog, {
      header: "Submit for approval",
      visible: _ctx.confirm,
      "onUpdate:visible": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.confirm) = $event)),
      style: { width: '450px' },
      modal: true
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          label: "Go Back",
          onClick: _ctx.closeToggle,
          class: "p-button-text"
        }, null, 8, ["onClick"]),
        _createVNode(_component_BaseButton, {
          onClick: _ctx.onSubmit,
          customStyle: _ctx.btnStyle
        }, {
          default: _withCtx(() => [
            _createTextVNode("Confirm Submission")
          ]),
          _: 1
        }, 8, ["onClick", "customStyle"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_64, [
          _createElementVNode("span", null, [
            _createTextVNode("Are you sure you are submitting your "),
            _createElementVNode("strong", null, "\"" + _toDisplayString(_ctx.form.title) + "\"", 1),
            _createTextVNode(" to"),
            _hoisted_65,
            _createElementVNode("strong", null, _toDisplayString(_ctx.form.supervisorEmail), 1),
            _createTextVNode(" for approval")
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_Dialog, {
      header: " ",
      visible: _ctx.sent,
      "onUpdate:visible": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.sent) = $event)),
      style: { width: '450px' },
      modal: true
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          label: "Go Back",
          onClick: _ctx.closeToggle2,
          class: "p-button-primary",
          "aria-label": "Back"
        }, null, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_66, [
          _createElementVNode("p", null, [
            _createTextVNode(" Your "),
            _createElementVNode("strong", null, "\"" + _toDisplayString(_ctx.prevTitle) + "\"", 1),
            _createTextVNode(" has been submitted to "),
            _createElementVNode("strong", null, _toDisplayString(_ctx.supervisorEmail), 1),
            _createTextVNode(" for approval. Please check your email for feedback from your supervisor."),
            _hoisted_67,
            _createTextVNode("You can also reach out to your supervisor to speed up the process. ")
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_Dialog, {
      visible: _ctx.termsModal,
      "onUpdate:visible": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.termsModal) = $event)),
      style: { width: '50rem' },
      breakpoints: { '600px': '85vw' },
      modal: true,
      header: " ",
      class: "hide_cloe",
      dismissableMask: true
    }, {
      default: _withCtx(() => [
        _createVNode(_component_TermsAndConditions)
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}